module.exports = __webpack_public_path__ + "img/feicheng.c66e829f.png";